import { PipelineFailedProvision } from '@/types/streams/pipeline'

import { Column, COLUMN_CELL_TYPE, Filter } from '../table/base'
import { formatDateTime } from './utils'

export const PIPELINE_FAILED_HEADERS: Column<PipelineFailedProvision>[] = [
  { id: 'eventId', label: 'Event ID', type: COLUMN_CELL_TYPE.TEXT, sortAttribute: 'eventId' },
  {
    id: 'eventTitle',
    label: 'Event Title',
    type: COLUMN_CELL_TYPE.TEXT,
    sortAttribute: 'eventTitle'
  },
  {
    id: 'eventStartDate',
    label: 'Start Date / Time',
    type: COLUMN_CELL_TYPE.COMPONENT,
    render: formatDateTime
  },
  {
    id: 'eventEndDate',
    label: 'End Date / Time',
    type: COLUMN_CELL_TYPE.COMPONENT,
    render: formatDateTime
  },
  { id: 'retryCount', label: 'Retry Count', type: COLUMN_CELL_TYPE.NUMBER }
]

export const pipelineFailedProvisionFilters: Filter<PipelineFailedProvision>[] = [
  {
    paramName: 'eventId',
    type: 'freeTextSearch',
    filterOptions: (item, value) => {
      return (
        item.eventId?.toString().includes(value) ||
        item.eventTitle?.toString().toLowerCase().includes(value.toLowerCase())
      )
    }
  }
]
